import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { fetchOrganization } from '@common/resources/Organization/actions';
import {
	fetchDepartments,
	fetchDepartmentsByOrganization,
	clearDepartments,
} from '@resources/Department/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { DepartmentItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';

const { Content } = Layout;

const Department = (props) => {
	const {
		departments,
		fetchDepartments,
		fetchDepartmentsByOrganization,
		clearDepartments,
		organization,
	} = props;
	const intl = useIntl();
	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);

	useEffect(() => {
		const func = async () => {
			await clearDepartments();

			organization?._id
				? await fetchDepartmentsByOrganization(organization?._id)
				: await fetchDepartments();
		};

		func();
	}, [
		fetchDepartments,
		fetchDepartmentsByOrganization,
		clearDepartments,
		organization,
	]);

	const parseDataSource = useCallback(() => {
		return departments.map((department) => {
			return {
				key: department._id,
				...department,
			};
		});
	}, [departments]);

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.department.management',
						defaultMessage: 'Department Management',
					})}
				</title>
			</Helmet>
			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>

			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>
			<Container>
				<View>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.departments"
									defaultMessage="Departments"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.department"
									defaultMessage="New Department"
								/>
							</Button>
						</Col>
					</Row>
					{parseDataSource() &&
						parseDataSource().map((department, index) => (
							<DepartmentItem
								key={`department-${index}`}
								department={department}
								onEdit={() => setUpdate(department._id)}
							/>
						))}
				</View>
			</Container>
		</Content>
	);
};

const mapStateToProps = ({
	departments,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		departments,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	fetchOrganization,
	fetchDepartments,
	fetchDepartmentsByOrganization,
	clearDepartments,
})(Department);
